import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface TutorialOverlayProps {
    step: {
        title: string;
        message: string;
        actionRequired?: boolean;
    };
    onNext: () => void;
    canProceed: boolean;
}

const TutorialOverlay: React.FC<TutorialOverlayProps> = ({ step, onNext, canProceed }) => {
    return (
        <div className="absolute inset-x-0 bottom-8 z-50 flex justify-center pointer-events-none">
            <AnimatePresence mode='wait'>
                <motion.div
                    key={step.title}
                    initial={{ y: 50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 20, opacity: 0 }}
                    className="bg-slate-900/90 backdrop-blur-md border border-gold-500/50 p-6 rounded-xl max-w-2xl w-full shadow-[0_0_30px_rgba(0,0,0,0.8)] pointer-events-auto flex gap-6 items-center"
                >
                    {/* Guardian Avatar (Static for now) */}
                    <div className="w-16 h-16 rounded-full border-2 border-gold-400 overflow-hidden shrink-0 shadow-[0_0_15px_rgba(250,204,21,0.3)]">
                        <div className="w-full h-full bg-slate-800 flex items-center justify-center text-2xl">
                            🧙‍♂️
                        </div>
                    </div>

                    <div className="flex-1">
                        <h3 className="text-gold-400 font-bold uppercase tracking-wider text-sm mb-1">
                            Le Gardien
                        </h3>
                        <p className="text-gray-100 text-lg leading-relaxed font-light">
                            {step.message}
                        </p>
                    </div>

                    {/* Action Button */}
                    <button
                        onClick={onNext}
                        disabled={!canProceed}
                        className={`
                            px-6 py-3 rounded-lg font-bold uppercase tracking-wide transition-all
                            ${canProceed
                                ? 'bg-gold-500 text-black hover:bg-gold-400 hover:scale-105 shadow-[0_0_20px_rgba(250,204,21,0.4)]'
                                : 'bg-slate-700 text-slate-500 cursor-not-allowed border border-slate-600'}
                        `}
                    >
                        {canProceed ? (step.actionRequired ? "Continuer" : "Continuer") : "En attente..."}
                    </button>
                </motion.div>
            </AnimatePresence>
        </div>
    );
};

export default TutorialOverlay;
